export const MAIN_CLASS_NAME = 'toolset-list-item';
export const HEADER_CLASS_NAME = `${MAIN_CLASS_NAME}__header`;
export const TITLE_CLASS_NAME = `${HEADER_CLASS_NAME}__title`;
export const ACTION_CLASS_NAME = `${TITLE_CLASS_NAME}__action`;
export const INFO_CLASS_NAME = `${HEADER_CLASS_NAME}__info`;
export const CONTEXT_CLASS_NAME = `${HEADER_CLASS_NAME}__context`;
export const FOOTER_CLASS_NAME = `${MAIN_CLASS_NAME}__footer`;
export const SECTION_CLASS_NAME = `${FOOTER_CLASS_NAME}__section`;

export const SKELETON_WIDTH = 384;
export const SKELETON_HEIGHT = 16;

export const DATE_TIME_TOOLSET_TOOL_COUNT = 1;
export const WEB_TOOLSET_TOOL_COUNT = 1;
